/**
 * Product Card Manager - Moon Moon Agency
 * Ajout rapide : le bouton est le COMPOSANT mm-cta (variante mm-btn-icon,
 * btn_icon_success: 'check'). Le morph + → ✓ vit dans l'atome : il suffit de
 * poser/retirer .is-added sur la racine du snippet — c'est son API d'état
 * documentée (le CSS de l'atome révèle .mm-btn__icon--success), le JS ne
 * touche jamais au markup des enfants.
 * L'ajout au panier réutilise window.CartAPI (mm_cart.js, chargé avant ce
 * script) — même requête (id + quantity + sections) et même event
 * cart:add-to-cart-success que le form natif data-type="add-to-cart-form",
 * pour que le toast/drawer/count se mettent à jour identiquement.
 */

/*********************************************************************************************
 * 🔧 PRODUCT CARD MANAGER
 */
const ProductCardManager = {
	config: {
		selectors: {
			quickAdd: '.mm-btn.mm-pcard__add',
			cart: '[data-cart], .mm-cart',
		},
		classes: {
			added: 'is-added',
		},
	},

	init() {
		this._bindEvents();
		window.log('info', '🔧 [PRODUCT_CARD]', 'Initialized');
	},

	_bindEvents() {
		document.addEventListener('click', (e) => {
			const btn = e.target.closest(this.config.selectors.quickAdd);
			if (!btn) return;
			// Produit multi-variantes : le bouton porte data-panel-open/aria-controls
			// (posé en Liquid depuis product.has_only_default_variant) — on laisse
			// mm-panel.js ouvrir la quick-add modal, pas d'ajout direct ici.
			if (btn.dataset.hasVariants === 'true') return;
			e.preventDefault();
			this._onQuickAdd(btn);
		});
	},

	_onQuickAdd(button) {
		if (button.classList.contains(this.config.classes.added) || button.disabled) return;
		if (!window.CartAPI) return;

		const variantId = button.getAttribute('data-product-id');
		if (!variantId) return;

		button.disabled = true;

		const formData = new FormData();
		formData.append('id', variantId);
		formData.append('quantity', 1);

		const cartEl = window.getElement(this.config.selectors.cart);
		const sectionId = cartEl ? cartEl.id.replace('shopify-section-', '') : '';
		if (sectionId) formData.append('sections', sectionId);

		window.CartAPI.request('POST', 'cart/add.js', formData)
			.then((response) => {
				button.classList.add(this.config.classes.added);
				document.dispatchEvent(new CustomEvent('cart:add-to-cart-success', {
					detail: { data: { variantId, quantity: 1, response } },
				}));
				window.setTimeout(() => {
					button.classList.remove(this.config.classes.added);
				}, 2000);
			})
			.catch((error) => {
				document.dispatchEvent(new CustomEvent('cart:add-to-cart-error', {
					detail: { data: { variantId, quantity: 1, error: error.message } },
				}));
				window.log('error', '🔧 [PRODUCT_CARD]', 'Quick add failed', { error: error.message });
			})
			.finally(() => {
				button.disabled = false;
			});
	},
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => ProductCardManager.init());
} else {
	ProductCardManager.init();
}
